"use client";

import { useState } from "react";
import ServiceList from "@/components/ServiceList/ServiceList";
import { servicesFilterTranslations } from "@/lib/servicesTranslations";

export default function ServicesFilter({ locale }: { locale: "pt" | "en" }) {
  const [search, setSearch] = useState("");
  const t = servicesFilterTranslations[locale] ?? servicesFilterTranslations["pt"];

  return (
    <div>
      <h2 className="text-xl text-[#1B475D] font-bold mb-6">{t.heading}</h2>
      <div className="flex items-center gap-3 mb-10">
        <input
          type="text"
          placeholder={t.placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-1 bg-white px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-[#77A885]"
        />
        <button className="bg-[#8EBD9D] hover:bg-[#77A885] text-[#1B475D] px-4 py-2 rounded-md font-semibold">
          {t.button}
        </button>
      </div>
      <ServiceList search={search} />
    </div>
  );
}
